/** Copies into a standalone ArrayBuffer; needed because pdf-lib returns views over ArrayBufferLike. */
export function toArrayBuffer(bytes: ArrayBuffer | Uint8Array): ArrayBuffer {
  return bytes instanceof Uint8Array ? bytes.slice().buffer : bytes
}

export async function sha256Hex(
  bytes: ArrayBuffer | Uint8Array
): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', toArrayBuffer(bytes))
  return [...new Uint8Array(digest)]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}
